import { schema } from 'normalizr';
import { CALL_API } from '../middleware/api';

// ACTIONS
export const MASTER_CONFIGURATION_LOGS_FETCH_REQUEST =
  'masterConfigurationLogs/MASTER_CONFIGURATION_LOGS_FETCH_REQUEST';
export const MASTER_CONFIGURATION_LOGS_FETCH_SUCCESS =
  'masterConfigurationLogs/MASTER_CONFIGURATION_LOGS_FETCHED_SUCCESS';
export const MASTER_CONFIGURATION_LOGS_FETCH_ERROR =
  'masterConfigurationLogs/MASTER_CONFIGURATION_LOGS_FETCHED_ERROR';

// REDUCER
export default function reducer(
  state = {
    entities: null,
    result: [],
    current: null,
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case MASTER_CONFIGURATION_LOGS_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case MASTER_CONFIGURATION_LOGS_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        entities: action.payload.entities.masterConfigurationLogs,
        result: action.payload.result,
      };

    case MASTER_CONFIGURATION_LOGS_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// Schemas
export const masterConfigurationLogSchema = new schema.Entity(
  'masterConfigurationLogs'
);

// Operations
export function fetchMasterConfigurationLogs(params) {
  return {
    [CALL_API]: {
      types: [
        MASTER_CONFIGURATION_LOGS_FETCH_REQUEST,
        MASTER_CONFIGURATION_LOGS_FETCH_SUCCESS,
        MASTER_CONFIGURATION_LOGS_FETCH_ERROR,
      ],
      promise: (httpClient) =>
        httpClient.post('/masterConfigurationLog', params),
      schema: { data: [masterConfigurationLogSchema] },
    },
  };
}
